{
  "sources": "Fuentes",
  "prompt": "Escribe una invitación para comenzar a chatear con la asistencia",
  "assistant": "Asistente",
  "assistantPlaceholder": "Escribe aquí, usa Shift + Return para agregar una nueva línea",
  "audio": "¿Quieres audio?",
  "return-line": "Regresar para agregar una nueva línea",
  "send": "Enviar",
  "record": "Grabar",
  "recording": "Grabando",
  "promptSelector": "Instrucción del asistente",
  "promptDefault": "Predeterminada",
  "promptLoading": "Cargando instrucciones personalizadas...",
  "promptEmpty": "No hay instrucciones personalizadas. Se usa el comportamiento predeterminado del asistente.",
  "promptUnavailable": "Las instrucciones personalizadas no están disponibles. Se usa el comportamiento predeterminado del asistente.",
  "promptInitializationError": "No se pudo inicializar el asistente. Se usa el comportamiento predeterminado del asistente.",
  "promptChangeTitle": "Cambiar instrucción del asistente",
  "promptChangeTitleWithName": "Cambiar instrucción del asistente a \"{{name}}\"",
  "promptChangeMessage": "Al cambiar la instrucción se borrará la conversación actual. ¿Desea continuar?",
  "promptChangeConfirm": "Sí, cambiar",
  "promptChangeDescriptionLabel": "Descripción de la instrucción",
  "promptDescriptionUnavailable": "No hay una descripción disponible para esta instrucción.",
  "showThoughts": "Mostrar pensamientos",
  "hideThoughts": "Ocultar pensamientos",
  "showToolCalls": "Mostrar llamadas de herramientas ({{count}})",
  "hideToolCalls": "Ocultar llamadas de herramientas ({{count}})",
  "showSubAgentWork": "Mostrar trabajo del subagente ({{count}})",
  "hideSubAgentWork": "Ocultar trabajo del subagente ({{count}})"
}
